
import { Suspense } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Process from './components/Process';
import Portfolio from './components/Portfolio';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import About from './components/About';
import CTA from './components/CTA';
import Footer from './components/Footer';
import WhatsAppButton from '../../components/WhatsAppButton';
import SEOHead from '../../components/SEOHead';

export default function Home() {
  return (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
    </div>}>
      <SEOHead />
      <div className="min-h-screen bg-white">
        <Header />
        <Hero />
        <Services />
        <WhyChooseUs />
        <Process />
        <Portfolio />
        <ServiceAreas />
        <Testimonials />
        <About />
        <CTA />
        <Footer />
        <WhatsAppButton />
      </div>
    </Suspense>
  );
}
